import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import jsPDF from "jspdf";
import "jspdf-autotable";
import React, { useState } from "react";
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import { api_Routes } from "../../../tools/api_Routes";
import { Helper } from "../../../tools/Helper";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const DataTable = ({ data, getData }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [pendingChange, setPendingChange] = useState({
    id: null,
    status: null,
  });
  const [loadingId, setLoadingId] = useState(null);

  const handleStatusChange = async (id, newStatus) => {
    try {
      setLoadingId(id);
      const { response, message } = await Helper.Post({
        url: `${api_Routes.UserAds.UpdateStatus}/${id}`,
        hasToken: true,
        data: { status: newStatus },
      });

      if (!response) {
        throw new Error(message || "Failed to update status");
      }

      await getData();
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setLoadingId(null);
      setShowConfirmDialog(false);
    }
  };
  const handleStatusChangeInit = (id, newStatus) => {
    setPendingChange({ id, status: newStatus });
    setShowConfirmDialog(true);
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Ads Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [
        ["ID", "Title", "Address", "Price", "Status", "Category", "User ID"],
      ],
      body: data.map((item) => [
        item.id,
        item.title,
        item.address,
        item.price,
        item.status,
        item.ad_sub_category_type_id,
        item.user_id,
      ]),
    });
    doc.save("ads_table.pdf");
  };

  const statusOptions = [
    "in_progress",
    "active",
    "complete",
    "pending",
    "cancel",
  ];

  return (
    <>
      {/*<button*/}
      {/*  onClick={exportPDF}*/}
      {/*  className="bg-primary text-white p-2 rounded mb-3"*/}
      {/*>*/}
      {/*  Export to PDF*/}
      {/*</button>*/}
      <Dialog
        open={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
      >
        <DialogTitle>Confirm Status Change</DialogTitle>
        <DialogContent>
          {pendingChange.id && (
            <p>
              Are you sure you want to change status for Ad #{pendingChange.id}{" "}
              to <strong>{pendingChange.status.replace("_", " ")}</strong>?
            </p>
          )}
        </DialogContent>
        <DialogActions>
          <button
            onClick={() => setShowConfirmDialog(false)}
            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
          >
            Cancel
          </button>
          <button
            onClick={() =>
              handleStatusChange(pendingChange.id, pendingChange.status)
            }
            className="px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark"
          >
            Confirm
          </button>
        </DialogActions>
      </Dialog>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                "id",
                "Subject",
                "Message",
                "Total count",
                "Total cost",
                "Total success",
                "Total fails",
                "Status",
              ].map((column) => (
                <TableCell
                  key={column}
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                >
                  <TableSortLabel
                    active={orderBy === column}
                    direction={orderBy === column ? order : "asc"}
                    onClick={() => handleSort(column)}
                  >
                    {column === "ad_sub_category_type_id"
                      ? "category"
                      : column === "user_id"
                      ? "user"
                      : column}
                  </TableSortLabel>
                </TableCell>
              ))}
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" align="center">
                  {item?.id}
                </TableCell>
                <TableCell sx={{maxWidth:'25%'}} align="center">{item?.subject}</TableCell>
                <TableCell sx={{maxWidth:'25%'}} align="center">{item?.message}</TableCell>
                <TableCell align="center">{item?.total_count}</TableCell>
                <TableCell align="center">
                  {item?.total_cost ? `${item?.total_cost}$` : "0$"}
                </TableCell>
                <TableCell align="center">{item?.total_success}</TableCell>
                <TableCell align="center">{item?.total_fails}</TableCell>
                <TableCell align="center">{item?.status}</TableCell>
                <TableCell align="center">
                  <Link
                    to={`/Smm-ticket-profile/Tickets/${item?.id}`}
                    color="inherit"
                    underline="none"
                  >
                    <FaEye className="text-blue-500" />
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;
